import { track } from 'src/tracking/trackingService';

const EVENT_PREFIX = 'marketing.management.facebook_business_extension';

const EVENTS = {
  LINK_CLICKED: `${EVENT_PREFIX}.link.clicked`,
  INTEGRATION_RESULT: `${EVENT_PREFIX}.integration.result`,
  BUSINESS_CONFIG_FAILURE: `${EVENT_PREFIX}.business_config.failure`,
  INTEGRATION_ASSETS_FAILURE: `${EVENT_PREFIX}.integration_assets.failure`,
  REINTEGRATION_RESULT: `${EVENT_PREFIX}.reintegration.result`,
  REINTEGRATION_ASSETS_FAILURE: `${EVENT_PREFIX}.reintegration_assets.failure`,
};

export interface FBEConnectedAccounts {
  facebook_connected: boolean;
  instagram_connected: boolean;
}

export const FacebookBusinessExtensionAnalytics = {
  trackLinkNowClicked: (source?: string | null) => {
    if (source) {
      track(EVENTS.LINK_CLICKED, { source });
      return;
    }
    track(EVENTS.LINK_CLICKED);
  },
  trackFBESuccess: (accounts: FBEConnectedAccounts) => {
    track(EVENTS.INTEGRATION_RESULT, { outcome: 'success', ...accounts });
  },
  trackFBEFailed: () => {
    track(EVENTS.INTEGRATION_RESULT, { outcome: 'failure' });
  },
  trackBusinessConfigFailure: () => {
    track(EVENTS.BUSINESS_CONFIG_FAILURE);
  },
  trackIntegrationAssetsFailure: () => {
    track(EVENTS.INTEGRATION_ASSETS_FAILURE);
  },
  trackFBEReintegrationSuccess: (accounts: FBEConnectedAccounts) => {
    track(EVENTS.REINTEGRATION_RESULT, { outcome: 'success', ...accounts });
  },
  trackFBEReintegrationFailure: (accounts?: FBEConnectedAccounts) => {
    track(EVENTS.REINTEGRATION_RESULT, { outcome: 'failure', ...accounts });
  },
  trackReintegrationAssetsFailure: () => {
    track(EVENTS.REINTEGRATION_ASSETS_FAILURE);
  },
};
